import RecordPage from '../../layouts/recordPage'

const Record: React.FC = () => {
    return <RecordPage />;
};

export default Record;
